import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const guest = getGuestTokens();
  if (guest.length) config.headers["X-Guest-Token"] = guest.join(",");
  return config;
});

export function getGuestTokens() {
  try { return JSON.parse(localStorage.getItem("ss_guest_tokens") || "[]"); } catch { return []; }
}

export const addGuestToken = (t) => {
  if (!t) return;
  const list = [t, ...getGuestTokens().filter((x) => x !== t)].slice(0, 20);
  localStorage.setItem("ss_guest_tokens", JSON.stringify(list));
};

export const setToken = (t) => {
  if (t) localStorage.setItem("ss_token", t);
  else localStorage.removeItem("ss_token");
};

export const getToken = () => localStorage.getItem("ss_token");
